export default __webpack_public_path__ + "static/social_share_dog2-c8c3816a19654966af88bdf9920c23d5.png";